import { Link } from "react-router-dom";
import Iconify from "../../../layouts/components/iconify/iconify";



export const renderGridAction = (rowData, col, rowIndex, onActionHandler, allowEditGrid, isRowEditable, onEditRow) => {


  if (!col.defaultAction) {
    col.defaultAction = {
      allowEdit: true,
      allowDelete: true,
    };
  }

  if (col.renderCustomAction) {
    col?.renderCustomAction(rowData, col);
  }

  const resolveActionFlag = (flag) => {
    if (typeof flag === "function") {
      return flag(rowData, rowIndex);
    }
    return flag;
  };

  const allowEdit = resolveActionFlag(col.defaultAction.allowEdit);
  const allowDelete = resolveActionFlag(col.defaultAction.allowDelete);

  const handleAction = (actionName, data, rowIndex) => {
    if (onActionHandler) {
      if (onActionHandler[actionName]) {
        onActionHandler[actionName](data, rowIndex);
      }
    }
  };

  // this method help user to check if row edit enable then allow to make it editable
  const handleRowEdit = (actionName, data, rowIndex) => {
    if (!isRowEditable && allowEditGrid) {
      if (onEditRow)
        onEditRow(rowIndex, data);
    }
    else {
      handleAction(actionName, data, rowIndex);
    }
  }

  const isEditingRow = allowEditGrid && isRowEditable;

  return (
    <div className="d-flex action-button">
      {!isEditingRow && col.customAction &&
        col.customAction.length > 0 &&
        col.customAction.map((action, index) => {
          const commonLinkProps = {
            key: `customAction_${index}`,
            onClick: (e) => {
              e.preventDefault();
              handleAction(action.name, rowData, rowIndex);
            },
            className: "mr-4",
            title: action.name,
            href: "",
          };
          // Add condition to check if rowData.contractInputFile is present
          if (action.name === "DOWNLOAD" && !rowData.contractInputFile) {
            return null;
          } else {
            // Render null if rowData.contractInputFile is not present
            return (
              <Link {...commonLinkProps}>
                <Iconify icon={action.iconClass || "basil:other-1-outline"} altText={action.name} />  
              </Link>
              // Please do not change this, icon is kept for default purposes
            );
          }
        })}


      {/* Edit Action Button */}
      {allowEdit && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            
            handleRowEdit("EDIT", rowData, rowIndex);
          }}
          className="mr-4 grid-edit-icon"
          title="EDIT"
        >
           <Iconify icon="line-md:pencil" />
        </Link>
      )}

      {/* Delete Action Button */}
      {!isEditingRow && allowDelete && (
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleAction("DELETE", rowData, rowIndex);
          }}
          className="mr-4 grid-delete-icon"
          title="DELETE"
        >
         <Iconify icon="mingcute:delete-2-line" />
        </Link>
      )}
    </div>
  );
};

